import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledDescription = styled.p`
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon["300"])};
    line-height: 16px;
    margin: 6px 0 0;
`;

export const StyledTitle = styled.h6`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon["500"])};
    line-height: 16px;
    margin: 0;
`;

export const StyledIcon = styled(SWReactIcons)`
    flex-shrink: 0;
    margin-right: 6px;
`;

export const StyledInner = styled.div`
    padding-top: 4px;
`;

export const StyledItem = styled.div`
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    padding: 16px 15px;

    &:hover {
        background-color: ${colorsPalettes.carbon["25"]};
    }
`;

export const StyledItemWrapper = styled.div`
    border-bottom: 1px solid ${colorsPalettes.carbon["100"]};
    cursor: pointer;
    padding: 8px 0;
`;
